import { Box, Button, Container, Flex, Heading, SimpleGrid, Spacer } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "scenes/layouts";
import ProductService from "services/products/product-service";
import LoadingScreen from "components/loading-screen";
import ProductCard from "./product-card";

const ProductListScene = (): ReactElement => {
    const navigate = useNavigate();
    const [products, setProducts] = useState<any>([]);
    const [isLoading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        setLoading(true);

        ProductService.GetAll(0, 100).then((response: any) => {
            setProducts(response.result.items);
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    const onClickProductCard = (product: any) => {
        navigate(`/products/${product.id}`);
    };

    if (isLoading)
        return <LoadingScreen />;

    return (
        <Layout>
            <Container maxWidth={"8xl"} mt={2} mb={5}>
                <Box>
                    <Heading fontSize={'3xl'} fontWeight={"extrabold"}>Produk</Heading>
                </Box>
                <Flex mt={3}>
                    <Spacer />
                    <Button onClick={() => navigate('/products/new')}>Buat Produk Baru</Button>
                </Flex>

                <SimpleGrid columns={[1, 2, 4]} gap={3} mt={3}>
                    {
                        products.map((product: any) => {
                            return (
                                <ProductCard name={product.name} price={product.price} imageUrl={product.firstProductImage.imageUrl} isNew={true} sold={product.sold} product={product} onClick={onClickProductCard} key={product.id} />
                            );
                        })
                    }
                </SimpleGrid>

            </Container>
        </Layout>
    );
};

export default ProductListScene;